import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Card, Button } from "@dpdgroupuk/mydpd-ui";
import { DpdCircleBoxIcon, DpdLocalCircleBoxIcon } from "../../../components/Icon";
import "./styles.scss";

const Tile = ({
  dpdLocal,
  text,
  onLaunch
}) => /*#__PURE__*/React.createElement(Card.Stack, {
  className: classNames("mydpd-platform-tile")
}, /*#__PURE__*/React.createElement(Card, null, dpdLocal ? /*#__PURE__*/React.createElement(DpdLocalCircleBoxIcon, {
  className: classNames("logo")
}) : /*#__PURE__*/React.createElement(DpdCircleBoxIcon, {
  className: classNames("logo")
}), /*#__PURE__*/React.createElement("p", {
  className: classNames("text")
}, text), /*#__PURE__*/React.createElement(Button, {
  className: classNames("launch-button"),
  size: "sm",
  variant: "dark",
  onClick: onLaunch
}, "Launch")));

Tile.propTypes = {
  text: PropTypes.string,
  dpdLocal: PropTypes.bool,
  onLaunch: PropTypes.func
};
export default Tile;